import { ModalData }                            from '@/components/modal/Modal';
import useTranslations                          from '@/hooks/useTranslations';
import RelationRequestTargetResponseListBox     from '@/pages/Contacts/components/RelationRequestTargetResponseListBox';
import { Box }                                  from '@chakra-ui/react';
import { Text }                                 from '@chakra-ui/react';
import React                                    from 'react';
import { useTranslation }                       from 'react-i18next';

interface IRelationRequestsContainerProps {
	setModalData: React.Dispatch<React.SetStateAction<ModalData | undefined>>;
	setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const RelationRequestsContainer = (props: IRelationRequestsContainerProps) => {

	const { setModalData, setModalIsOpen } = props;
	const { t } = useTranslation();
	const { getNavigationTranslation } = useTranslations();

	const [relationRequestsTotal, setRelationRequestsTotal] = React.useState(0);
	
	return (
		<Box marginTop="10px">
			<Text
				className="poppins-semibold"
				fontSize="18px"
				marginBottom="20px"
			>
				<span>{t('pages.home.pendingRelationRequests.title')}</span>&nbsp;
				<span 
					className="poppins-light"
					style={{ 
						fontSize: '14px',
					}}
				>
						{`(${relationRequestsTotal})`}
				</span>
			</Text>
				<RelationRequestTargetResponseListBox 
					setModalData={setModalData}
					setModalIsOpen={setModalIsOpen}
					onListSuccess={(collection) => setRelationRequestsTotal(collection.total)}
					options={{ 
						withPagination: false,
						bottomLink: {
							label: t('pages.home.pendingRelationRequests.link'),
							to: getNavigationTranslation('contacts', 'path') + '#' + getNavigationTranslation('contacts', 'hash'),
						}
					}}
				/>
		</Box>
	);
}

export default RelationRequestsContainer;